module.exports = __webpack_public_path__ + "img/bianji.1f39b578.png";